import React, { Component } from "react";
import  PayrollMain  from "./PayrollMain";

export default class PayslipGenerate1 extends Component {

  render() {
    return <PayrollMain id={3} />;
  }
}
